import { WrenchTheme } from '@wds/styles';
import merge from 'lodash.merge';

const theme = {
  brandColors: {
    primary: {
      sabaeus: '#00BF6F',
      midnight: '#05467E',
      concord: '#671E75',
      arctic: '#2DCCD3',
    },
    accent: {
      bumblebee: '#F9BE00',
      bengal: '#F05B24',
      raspberry: '#AC145A',
    },
    neutral: {
      white: '#FFFFFF',
      black: '#000000',
      charcoal: '#333E48',
      slate: '#6C777D',
      stone: '#9DA5AA',
      flint: '#D0D2D3',
    },
  },
  endpageColors: {
    embeddedNonBranded: {
      backgroundColor: '#efefef',
    },
    onHover: {
      transparentWhite: '#ffffffe6',
      lighterBumblebee: '#FFCD2D',
    },
  },
  util: {
    fullHeight: '100vh',
  },
};

export default merge({}, WrenchTheme, theme);
